<template>
  <Header />
  <div id="appCapsule">
    <div class="section full mt-2 mb-2">
      <div class="section-title">
        <span>انتقادات و شکایات</span>
            <!-- <router-link class="item" active-class='active' to="/"> -->
        <span>
          <router-link to="/feedbackFollow">پیگیری شکایات</router-link>
        </span>
      </div>
      <div class="wide-block pt-2 pb-3">
        <form>
          <div class="form-group basic animated">
            <div class="input-wrapper">
              <label class="label" for="title">عنوان</label>
              <input
                type="text"
                class="form-control"
                id="title"
                v-model.lazy.trim="postData.title"
                required
              />
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>

          <div class="form-group basic animated">
            <div class="input-wrapper">
              <label class="label" for="message">پیام شما</label>
              <textarea
                class="form-control"
                v-model.lazy.trim="postData.message"
                name="message"
                rows="5"
              ></textarea>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>
          
          <div class="mt-2">
            <button v-if="loading == 0"
              @click.prevent="validation"
              class="btn background-ORANGE text-light btn-block"
              type="submit"
            >
              ارسال
            </button>
            <button
              v-else
              class="btn background-ORANGE text-light btn-block"
              type="button"
              disabled=""
            >
              <span
                class="spinner-border spinner-border-sm me-05"
                role="status"
                aria-hidden="true"
              ></span>
              درحال بارگذاری ...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <Footer />
</template>
  
<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { reactive, ref } from "vue";

export default {
  name: "feedback",
  components:{
    Header,
    Footer
  },
  setup() {
    const postData = reactive({
      title: "",
      phoneNumber: "",
      // complaint: "",
      titleErrorText: "",
      phoneNumberErrorText: "",
      // complaintErrorText: "",
    });
    const loading = ref(false);


    function validation() {
        
      if (postData.title === "") {
        postData.titleErrorText = "عنوان اجباری است";
      }
      if (postData.title !== "") {
        createPost();
      }
    }

    function createPost() {

      const axiosConfig = {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      };
      // console.log(postData);
      loading.value = 1;
      axios
        .post(
          `https://core.iran-tarabar.ir/api/driver/storeComplaintDriver`,
          postData, axiosConfig
        )
        .then((response) => {
            loading.value = 0;
          console.log(response);
          Swal.fire({
            title: `کد پیگیری: ${response.data.data.trackingCode}`,
            text: "پیام شما برای تیم پشتیبانی ارسال شد!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "حله",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }
    return { postData, createPost, validation, loading };
  },
};
</script>
  
<style scoped></style>